import { globalStyles } from "@client/shared/constants";
const { display, flex, text } = globalStyles;

const dialogStyles = {
  dialogContent: {
    width: "370px",
    borderBottom: "1px solid",
    borderColor: "grey.300",
  },
  dialogTitle: {
    ...text.align.right,
    padding: "6px",
  },
  checkboxWrapper: {
    ...display.flex,
    ...flex.align.center,
    marginTop: "12px",
    marginBottom: "8px",
    padding: 1,
  },

  heading: {
    fontWeight: "bold",
    marginTop: "8px",
    marginBottom: "8px",
  },
  actions: {
    padding: 2,
    ...flex.justify.center,
  },
  warningIcon: {
    width: "80px",
    height: "80px",
    transform: "rotate(180deg)",
    color: "#B6413F",
  },
  cancelBtn: {
    color: "grey.500",
    borderColor: "grey.500",
  },
  actionButtons: {
    width: "140px",
    padding: "6px",
  },
};

export default dialogStyles;
